// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#promobanner{  
    background-color: #7d7d7d !important; 
  }`, "",{"version":3,"sources":["webpack://./src/app/home/home-item/home-item.component.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;EACtC","sourcesContent":["\r\n#promobanner{  \r\n    background-color: #7d7d7d !important; \r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
